"use strict";

exports.__esModule = true;
exports.iconMachineNameMapAll = exports.iconMachineNameMap = exports["default"] = exports.IconBase = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _recompose = require("recompose");

var _icons = require("../icons");

var _glyphs = _interopRequireDefault(require("../../components/glyphs"));

var _custom = _interopRequireDefault(require("../../primitives/custom"));

var _excluded = ["id"],
    _excluded2 = ["Constructor"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var iconMachineNameMap = {
  account: _icons.AccountIcon,
  "arrow-dotted": _icons.ArrowDottedIcon,
  "arrow-left": _icons.ArrowLeftIcon,
  "arrow-right": _icons.ArrowRightIcon,
  automotive: _icons.AutomotiveIcon,
  baidu: _icons.BaiduIcon,
  blog: _icons.BlogIcon,
  bullet: _icons.BulletIcon,
  "bullet-filled": _icons.BulletFilledIcon,
  checkmark: _icons.CheckmarkIcon,
  chevron: _icons.ChevronIcon,
  "chevron-left": _icons.ChevronLeftIcon,
  chipset: _icons.ChipsetIcon,
  "circle-check": _icons.CircleCheckIcon,
  "circle-close": _icons.CircleCloseIcon,
  "circle-down": _icons.CircleDownIcon,
  "circle-empty": _icons.CircleEmptyIcon,
  "circle-exclamation": _icons.CircleExclamationIcon,
  "circle-filled": _icons.CircleFilledIcon,
  "circle-minus": _icons.CircleMinusIcon,
  "circle-play": _icons.CirclePlayIcon,
  "circle-plus": _icons.CirclePlusIcon,
  "circle-right": _icons.CircleRightIcon,
  "circle-up": _icons.CircleUpIcon,
  close: _icons.CloseIcon,
  "close-2": _glyphs["default"].close,
  "company-20": _icons.Company20Icon,
  "control-close": _icons.ControlCloseIcon,
  "control-index": _icons.ControlIndexIcon,
  "control-index-20": _icons.ControlIndex20Icon,
  "control-next": _icons.ControlNextIcon,
  "control-previous": _icons.ControlPreviousIcon,
  "control-top": _icons.ControlTopIcon,
  "delete": _icons.DeleteIcon,
  "dev-kit": _icons.DevKitIcon,
  doc: _icons.DocIcon,
  download: _icons.DownloadIcon,
  education: _icons.EducationIcon,
  email: _icons.EmailIcon,
  enlarge: _icons.EnlargeIcon,
  eye: _icons.EyeIcon,
  facebook: _icons.FacebookIcon,
  filter: _icons.FilterIcon,
  "footer-language": _icons.FooterLanguageIcon,
  "footer-line-zigzag": _icons.FooterLineZigzagIcon,
  "footer-site-map": _icons.FooterSiteMapIcon,
  "footer-sites": _icons.FooterSitesIcon,
  globe: _icons.GlobeIcon,
  google: _icons.GoogleIcon,
  hamburger: _icons.HamburgerIcon,
  "hamburger-20": _icons.Hamburger20Icon,
  healthcare: _icons.HealthcareIcon,
  home: _icons.HomeIcon,
  "home-20": _icons.Home20Icon,
  image: _icons.ImageIcon,
  info: _icons.InfoIcon,
  "info-20": _icons.Info20Icon,
  instagram: _icons.InstagramIcon,
  "internet-of-everything": _icons.InternetOfEverythingIcon,
  "invention-20": _icons.Invention20Icon,
  link: _icons.LinkIcon,
  "link-out": _icons.LinkOutIcon,
  linkedin: _icons.LinkedinIcon,
  list: _icons.ListIcon,
  loading: _icons.LoadingIcon,
  "loading-dark": _icons.LoadingDarkIcon,
  "logo-q": _icons.LogoQIcon,
  "logo-qualcomm": _icons.LogoQualcommIcon,
  "logo-qualcomm-china": _icons.LogoQualcommChinaIcon,
  "med-cta": _icons.MedCtaIcon,
  "mobile-computing": _icons.MobileComputingIcon,
  modem: _icons.ModemIcon,
  more: _icons.MoreIcon,
  "more-20": _icons.More20Icon,
  networking: _icons.NetworkingIcon,
  "news-20": _icons.News20Icon,
  pdf: _icons.PdfIcon,
  pin: _icons.PinIcon,
  platform: _icons.PlatformIcon,
  play: _icons.PlayIcon,
  podcast: _icons.PodcastIcon,
  ppt: _icons.PptIcon,
  "press-release": _icons.PressReleaseIcon,
  "product-charging": _icons.ProductChargingIcon,
  "product-chipsets": _icons.ProductChipsetsIcon,
  "product-consumer": _icons.ProductConsumerIcon,
  "product-hardware": _icons.ProductHardwareIcon,
  "product-software": _icons.ProductSoftwareIcon,
  "product-wireless": _icons.ProductWirelessIcon,
  qq: _icons.QqIcon,
  qzone: _icons.QzoneIcon,
  "reference-design": _icons.ReferenceDesignIcon,
  renren: _icons.RenrenIcon,
  replay: _icons.ReplayIcon,
  "ring-alt": _icons.RingAltIcon,
  rss: _icons.RssIcon,
  sdk: _icons.SdkIcon,
  search: _icons.SearchIcon,
  "search-20": _icons.Search20Icon,
  select: _icons.SelectIcon,
  "share-icon": _icons.ShareIconIcon,
  "shopping-cart": _icons.ShoppingCartIcon,
  "smart-cities": _icons.SmartCitiesIcon,
  "smart-homes": _icons.SmartHomesIcon,
  soc: _icons.SocIcon,
  "social-facebook": _icons.SocialFacebookIcon,
  "social-facebook-inverted": _icons.SocialFacebookInvertedIcon,
  "social-flickr-background": _icons.SocialFlickrBackgroundIcon,
  "social-google": _icons.SocialGoogleIcon,
  "social-google-inverted": _icons.SocialGoogleInvertedIcon,
  "social-instagram": _icons.SocialInstagramIcon,
  "social-instagram-inverted": _icons.SocialInstagramInvertedIcon,
  "social-linkedin": _icons.SocialLinkedinIcon,
  "social-linkedin-inverted": _icons.SocialLinkedinInvertedIcon,
  "social-pinterest": _icons.SocialPinterestIcon,
  "social-pinterest-inverted": _icons.SocialPinterestInvertedIcon,
  "social-tumblr": _icons.SocialTumblrIcon,
  "social-twitter": _icons.SocialTwitterIcon,
  "social-twitter-inverted": _icons.SocialTwitterInvertedIcon,
  "social-youtube": _icons.SocialYoutubeIcon,
  "social-youtube-inverted": _icons.SocialYoutubeInvertedIcon,
  "solutions-20": _glyphs["default"].solutions,
  tablet: _icons.TabletIcon,
  tag: _icons.TagIcon,
  tumblr: _icons.TumblrIcon,
  twitter: _icons.TwitterIcon,
  "twitter-b": _icons.TwitterBIcon,
  txt: _icons.TxtIcon,
  "up-down": _icons.UpDownIcon,
  video: _icons.VideoIcon,
  wearables: _icons.WearablesIcon,
  webinar: _icons.WebinarIcon,
  wechat: _icons.WechatIcon,
  weibo: _icons.WeiboIcon,
  wifi: _icons.WifiIcon,
  xls: _icons.XlsIcon,
  youku: _icons.YoukuIcon,
  youtube: _icons.YoutubeIcon,
  zip: _icons.ZipIcon
};
exports.iconMachineNameMap = iconMachineNameMap;
var iconMachineNameMapAll = (0, _ramda.merge)(iconMachineNameMap, _glyphs["default"]);
exports.iconMachineNameMapAll = iconMachineNameMapAll;
var enhance = (0, _recompose.compose)((0, _recompose.mapProps)(function (_ref) {
  var id = _ref.id,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return Object.assign({
    Constructor: (0, _ramda.prop)(id, iconMachineNameMapAll)
  }, props);
}), (0, _recompose.branch)((0, _ramda.propSatisfies)(_ramda.isNil, "Constructor"), _recompose.renderNothing));
var propTypes = {
  id: _propTypes.string.isRequired
};
/**
 * Generic icon component for rendering SVG icons. Takes ID prop and maps it to
 * corresponding icon component. This is useful for rendering icons which are
 * not known until runtime. If the icon id is known at build time it is best to
 * import that icon directly from the Icons directory. Icon components render
 * their SVG markup inline. This allows full usage of SVG styling via CSS and
 * has the best browser compatibility.
 */

var IconBase = enhance(function (_ref2) {
  var Constructor = _ref2.Constructor,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(Constructor, props);
});
exports.IconBase = IconBase;
var Icon = (0, _styledComponents["default"])(IconBase).withConfig({
  displayName: "icon__Icon",
  componentId: "sc-10sq418-0"
})(["", ";"], _custom["default"]);
Icon.propTypes = propTypes;
var _default = Icon;
exports["default"] = _default;